import { render } from "./ModalAddLinkVideo.vue?vue&type=template&id=6ad37baa&scoped=true"
import script from "./ModalAddLinkVideo.vue?vue&type=script&lang=js"
export * from "./ModalAddLinkVideo.vue?vue&type=script&lang=js"

import "./ModalAddLinkVideo.vue?vue&type=style&index=0&id=6ad37baa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad37baa"]])

export default __exports__